require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-statements-temporarily-unavailable.json") })
        }
      }, "path---es-articles-statements-temporarily-unavailable");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-statements-temporarily-unavailable!./.cache/json/es-articles-statements-temporarily-unavailable.json
// module id = 2243
// module chunks = 231608221292675